/* tslint:disable */
/* eslint-disable */
/**
 * Armasuisse Dashboard Web Application API
 * API definitions for Armasuisse Dashboard Web Application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PersonBase } from '../models';
// @ts-ignore
import { PersonBaseResponse } from '../models';
// @ts-ignore
import { PersonDetailResponse } from '../models';
// @ts-ignore
import { ProblemDetails } from '../models';
/**
 * PeopleApi - axios parameter creator
 * @export
 */
export const PeopleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates new People and returns newly created People.
         * @summary Creates new People.
         * @param {PersonBase} [personBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPeople: async (personBase?: PersonBase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/People`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(personBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete People.
         * @summary Delete People.
         * @param {number} entityID People identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePeople: async (entityID: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityID' is not null or undefined
            assertParamExists('deletePeople', 'entityID', entityID)
            const localVarPath = `/People/{entityID}`
                .replace(`{${"entityID"}}`, encodeURIComponent(String(entityID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the People.
         * @summary Get People details.
         * @param {number} entityID People identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeopleDetails: async (entityID: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityID' is not null or undefined
            assertParamExists('getPeopleDetails', 'entityID', entityID)
            const localVarPath = `/People/{entityID}`
                .replace(`{${"entityID"}}`, encodeURIComponent(String(entityID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of People.
         * @summary Get filtered list of People.
         * @param {string} [search] Search query.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeopleList: async (search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/People`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update People and returns the modified People.
         * @summary Edit People.
         * @param {number} entityID People identifier
         * @param {PersonBase} [personBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePeople: async (entityID: number, personBase?: PersonBase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityID' is not null or undefined
            assertParamExists('updatePeople', 'entityID', entityID)
            const localVarPath = `/People/{entityID}`
                .replace(`{${"entityID"}}`, encodeURIComponent(String(entityID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(personBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PeopleApi - functional programming interface
 * @export
 */
export const PeopleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PeopleApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates new People and returns newly created People.
         * @summary Creates new People.
         * @param {PersonBase} [personBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPeople(personBase?: PersonBase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPeople(personBase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete People.
         * @summary Delete People.
         * @param {number} entityID People identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePeople(entityID: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePeople(entityID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the People.
         * @summary Get People details.
         * @param {number} entityID People identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPeopleDetails(entityID: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPeopleDetails(entityID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of People.
         * @summary Get filtered list of People.
         * @param {string} [search] Search query.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPeopleList(search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PersonBaseResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPeopleList(search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update People and returns the modified People.
         * @summary Edit People.
         * @param {number} entityID People identifier
         * @param {PersonBase} [personBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePeople(entityID: number, personBase?: PersonBase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePeople(entityID, personBase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PeopleApi - factory interface
 * @export
 */
export const PeopleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PeopleApiFp(configuration)
    return {
        /**
         * Creates new People and returns newly created People.
         * @summary Creates new People.
         * @param {PersonBase} [personBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPeople(personBase?: PersonBase, options?: any): AxiosPromise<PersonDetailResponse> {
            return localVarFp.addPeople(personBase, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete People.
         * @summary Delete People.
         * @param {number} entityID People identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePeople(entityID: number, options?: any): AxiosPromise<void> {
            return localVarFp.deletePeople(entityID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the People.
         * @summary Get People details.
         * @param {number} entityID People identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeopleDetails(entityID: number, options?: any): AxiosPromise<PersonDetailResponse> {
            return localVarFp.getPeopleDetails(entityID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of People.
         * @summary Get filtered list of People.
         * @param {string} [search] Search query.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeopleList(search?: string, options?: any): AxiosPromise<Array<PersonBaseResponse>> {
            return localVarFp.getPeopleList(search, options).then((request) => request(axios, basePath));
        },
        /**
         * Update People and returns the modified People.
         * @summary Edit People.
         * @param {number} entityID People identifier
         * @param {PersonBase} [personBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePeople(entityID: number, personBase?: PersonBase, options?: any): AxiosPromise<PersonDetailResponse> {
            return localVarFp.updatePeople(entityID, personBase, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PeopleApi - object-oriented interface
 * @export
 * @class PeopleApi
 * @extends {BaseAPI}
 */
export class PeopleApi extends BaseAPI {
    /**
     * Creates new People and returns newly created People.
     * @summary Creates new People.
     * @param {PersonBase} [personBase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public addPeople(personBase?: PersonBase, options?: AxiosRequestConfig) {
        return PeopleApiFp(this.configuration).addPeople(personBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete People.
     * @summary Delete People.
     * @param {number} entityID People identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public deletePeople(entityID: number, options?: AxiosRequestConfig) {
        return PeopleApiFp(this.configuration).deletePeople(entityID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the People.
     * @summary Get People details.
     * @param {number} entityID People identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public getPeopleDetails(entityID: number, options?: AxiosRequestConfig) {
        return PeopleApiFp(this.configuration).getPeopleDetails(entityID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of People.
     * @summary Get filtered list of People.
     * @param {string} [search] Search query.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public getPeopleList(search?: string, options?: AxiosRequestConfig) {
        return PeopleApiFp(this.configuration).getPeopleList(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update People and returns the modified People.
     * @summary Edit People.
     * @param {number} entityID People identifier
     * @param {PersonBase} [personBase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public updatePeople(entityID: number, personBase?: PersonBase, options?: AxiosRequestConfig) {
        return PeopleApiFp(this.configuration).updatePeople(entityID, personBase, options).then((request) => request(this.axios, this.basePath));
    }
}
